/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { Button, Input, Select } from 'antd';
import { useAnio, useModelos, useRepuestos, useVersion } from '../../../hooks/Front/outlet/useOutlet';
import { Label } from '../../views/contactanos/contactanos';
import { LayoutForm } from './flota';
import { useParams } from 'react-router';
import { useCategoriasRepuestos, useModelosRepuesto, useRepuestoSlug } from '../../../hooks/Front/repuestos';
import { checkIsNotEmpty } from '../../../helper/validations';
import { errorSwal } from '../../../helper/swalHelpers';

const Repuesto = ({ states }) => {
    const [form, setForm] = useState({
        idRepuesto: undefined,
        idVehiculo: undefined,
        cantidad: 1,
        tipo: "repuesto",
        idCategoriaRepuesto: undefined,
        comentarios: undefined,
        Modelo: undefined,
        Version: undefined,
        Anio: undefined,
        Modulo: "REPUESTO"
    });
    const [id, setId] = useState(undefined);
    const [producto, setProducto] = useState(undefined);

    const { idRepuesto, cantidad, idCategoriaRepuesto, comentarios, Modelo, Version, Anio } = form;

    const { slug, cantidad: cantidadSlug } = useParams();
    const { modelos: modelosRep, error: errorRep, loading: loadingRep } = useModelosRepuesto(id)
    const { categorias, error: errorC, loading: loadingC } = useCategoriasRepuestos()
    const { repuesto, loading: loadingR, error: errorR } = useRepuestoSlug(slug, "REPUESTO");
    const { modelos, error: errorM, loading: loadingM } = useModelos();
    const { versiones, error: errorV, loading: loadingV } = useVersion(Modelo);
    const { anios, error: errorA, loading: loadingA } = useAnio(Modelo, Version);
    const { repuestos, loading: loadingRe, error: errorRe } = useRepuestos(form);

    const handleChange = (name, value) => {
        if (name === 'Modelo') {
            if (id) {
                setForm({ ...form, [name]: value, Version: undefined, Anio: undefined });
            }
            else {
                setForm({ ...form, [name]: value, Version: undefined, Anio: undefined, idRepuesto: undefined });
                states.setProducto(undefined);
                setProducto(undefined);
            }
        }
        else if (name === 'Version') {
            if (id) {
                setForm({ ...form, [name]: value, Anio: undefined });
            }
            else {
                setForm({ ...form, [name]: value, Anio: undefined, idRepuesto: undefined });
                states.setProducto(undefined);
                setProducto(undefined);
            }
        }
        else if (name === 'Anio') {
            let obj = anios.filter(a => a.Anio === value)
            let idVehiculo;
            if (obj && obj.length > 0) {
                idVehiculo = obj[0].idVehiculo;
            }
            // console.log ("obj", obj);
            if (id) {
                setForm({ ...form, [name]: value, idVehiculo });
            }
            else {
                setForm({ ...form, [name]: value, idVehiculo, idRepuesto: undefined });
                states.setProducto(undefined);
                setProducto(undefined);
            }

        }
        else if (name === 'idCategoriaRepuesto') {
            if (id) {
                setForm({ ...form, [name]: value });
            }
            else {
                setForm({ ...form, [name]: value, idRepuesto: undefined });
                states.setProducto(undefined);
                setProducto(undefined);
            }

        }
        else if (name === 'idRepuesto') {
            let idx = repuestos.findIndex(rep => rep.idRepuesto === value);
            let repuesto = repuestos[idx];
            setProducto(repuesto);
            states.setProducto({ ...repuesto, tipo: "repuesto", cantidad });
            setForm({ ...form, [name]: value })
        }
        else if (name === 'comentarios') {
            setForm({ ...form, [name]: value })
        }
    }

    const handleChangeRestar = () => {
        if (cantidad >= 2) {
            let newCantidad = cantidad - 1;
            setForm({ ...form, cantidad: newCantidad });
            if (producto) states.setProducto({ ...producto, tipo: "repuesto", cantidad: newCantidad });

        }

    }

    const handleChangeSumar = () => {
        if (cantidad < 10) {
            let newCantidad = cantidad + 1;
            setForm({ ...form, cantidad: newCantidad });
            if (producto) states.setProducto({ ...producto, tipo: "repuesto", cantidad: newCantidad })
        }
    };

    const validateForm = () => {
        if (
            !checkIsNotEmpty(Modelo) ||
            !checkIsNotEmpty(Version) ||
            !checkIsNotEmpty(Anio) ||
            !checkIsNotEmpty(idCategoriaRepuesto)
        ) return false;

        if (
            !checkIsNotEmpty(idRepuesto) &&
            !checkIsNotEmpty(comentarios)
        ) return false;

        return true;
    }

    const handleContinue = () => {
        if (!validateForm()) {
            errorSwal("Ocurrió un error", "Recuerda ingresar todos los campos requeridos.", "Ok");
            return;
        }

        states.setFormP(form);
        if (producto) states.setProducto({ ...producto, tipo: "repuesto", cantidad })

        states.setPaso(1);
    }

    useEffect(() => {
        if (repuesto && loadingR === false && errorR === false) {
            let ct = cantidadSlug ? cantidadSlug : 1
            setId(repuesto.idRepuesto);
            setForm({ ...form, idCategoriaRepuesto: repuesto.idCategoriaRepuesto, idRepuesto: repuesto.idRepuesto, cantidad: ct });
            setProducto(repuesto);
            states.setProducto({ ...repuesto, tipo: "repuesto", cantidad: ct });

        }
    }, [repuesto, loadingR, errorR, cantidadSlug])

    const getViewPortWidth = () => {
        let viewportwidth;
        // the more standards compliant browsers (mozilla/netscape/opera/IE7) use window.innerWidth and window.innerHeight
        if (typeof window.innerWidth != 'undefined') {
            viewportwidth = window.innerWidth;
            // IE6 in standards compliant mode (i.e. with a valid doctype as the first line in the document)
        } else
            if (typeof document.documentElement != 'undefined' &&
                typeof document.documentElement.clientWidth != 'undefined' &&
                document.documentElement.clientWidth != 0) {
                viewportwidth = document.documentElement.clientWidth;
                // older versions of IE
            } else {
                viewportwidth = document.getElementsByTagName('body')[0].clientWidth;
            }
        return viewportwidth;
    }

    return (
        <>
            <LayoutForm>
                <p className="bold-title-hyundai mb-3 f-responsive">Datos del vehículo</p>
                <Label texto="Modelo" />
                {id && modelosRep && modelosRep.length > 0 && errorRep === false ?
                    <Select className="w-100 hyundai-select" loading={loadingM} value={Modelo} onChange={v => handleChange("Modelo", v)}>
                        {modelosRep && modelosRep.length > 0 && errorM === false &&
                            modelosRep.map((modelo, i) =>
                                <Select.Option value={modelo.modelo} key={i}>{modelo.modelo}</Select.Option>
                            )
                        }
                    </Select>
                    :
                    <Select className="w-100 hyundai-select" loading={loadingM} value={Modelo} onChange={v => handleChange("Modelo", v)}>
                        {modelos && modelos.length > 0 && errorM === false &&
                            modelos.map((modelo, i) =>
                                <Select.Option value={modelo.Modelo} key={i}>{modelo.Modelo}</Select.Option>
                            )
                        }
                    </Select>
                }

            </LayoutForm>
            <LayoutForm>
                <Label texto="Versión" />
                <Select className="w-100 hyundai-select" loading={loadingV} value={Version} onChange={v => handleChange("Version", v)}>
                    {versiones && versiones.length > 0 && errorV === false &&
                        versiones.map((version, i) =>
                            <Select.Option value={version.Version} key={i}>{version.Version}</Select.Option>
                        )
                    }
                </Select>
            </LayoutForm>
            <LayoutForm>
                <Label texto="Año" />
                <Select className="w-100 hyundai-select" loading={loadingA} value={Anio} onChange={v => handleChange("Anio", v)}>
                    {anios && anios.length > 0 && errorA === false &&
                        anios.map((anio, i) =>
                            <Select.Option value={anio.Anio} key={i}>{anio.Anio}</Select.Option>
                        )
                    }
                </Select>
            </LayoutForm>
            <LayoutForm>
                <Label texto="Familia de repuestos" />
                <Select className="w-100 hyundai-select" loading={loadingC} value={idCategoriaRepuesto} disabled={id ? true : false} onChange={v => handleChange("idCategoriaRepuesto", v)}>
                    {categorias && categorias.length > 0 && errorC === false &&
                        categorias.map((categoria, i) =>
                            <Select.Option value={categoria.idCategoriaRepuesto} key={i}>{categoria.Nombre}</Select.Option>
                        )
                    }
                </Select>
            </LayoutForm>
            <LayoutForm>
                <Label texto="Repuesto específico" />
                {Modelo && Version && Anio && !id && ((!repuestos || repuestos.length < 1)) ?
                    <Input className="cotizar-input" onChange={e => handleChange("comentarios", e.target.value)} value={comentarios} />
                    :
                    <Select className="w-100 hyundai-select" loading={loadingRe} disabled={id ? true : false} value={idRepuesto} onChange={v => handleChange("idRepuesto", v)}>
                        {repuestos && repuestos.length > 0 && errorRe === false &&
                            repuestos.map((repuesto, i) =>
                                <Select.Option value={repuesto.idRepuesto} key={i}>{repuesto.Titulo} - {repuesto.DescripcionCorta}</Select.Option>
                            )
                        }
                    </Select>
                }

            </LayoutForm>
            
            <LayoutForm>
                <Label texto="Cantidad" />
                <button className="btn-unidad-ficha btn-restar" onClick={handleChangeRestar}>-</button>
                <Input className="input-unidad-hyundai" value={cantidad} readOnly />
                <button className="btn-unidad-ficha btn-sumar" onClick={handleChangeSumar}>+</button>
            </LayoutForm>

            {
                getViewPortWidth() <= 768 ? (
                    <div className='col-btn-formulario-cotizar mt-5'>
                        <Button
                            className="btn-primario-cotizador font-btn w-100 f-responsive mb-3"
                            onClick={handleContinue}
                        >
                            Siguiente
                        </Button>
                    </div>
                ) : (
                    <LayoutForm>
                        <Button className="btn-primario font-btn w-100 f-responsive mb-5" onClick={handleContinue}>Siguiente</Button>
                    </LayoutForm>
                )
            }
        </>
    );
}

export default Repuesto;